var _style, _rect, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVrr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 945.55 290.81",
    style: {
      enableBackground: "new 0 0 945.55 290.81"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#EA5546;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_2_);fill:#343434;}\r\n\t.st3{clip-path:url(#SVGID_2_);fill:#DADADA;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 945.55,
    height: 290.81
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 945.55,
    height: 290.81
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.74,121.54h5.69l22.85,59.34l22.66-59.34h5.69c-8.82,22.28-17.16,44.08-25.88,66.36h-4.93L251.74,121.54z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.82,127.03h-4.74v-5.5h4.74V127.03z M322.82,187.89h-4.74v-48.82h4.74V187.89z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.45,118.22v69.68h-4.36v-9.39c-2.46,4.17-8.82,10.81-18.67,10.81c-16.68,0-23.23-13.37-23.23-25.69 c0-18.48,11.94-25.97,22.75-25.97c10.81,0,15.92,4.93,18.77,9.86v-29.29H382.45z M359.6,142.01c-11.57,0-18.49,8.72-18.49,21.14 c0,9.57,4.74,21.8,18.49,21.8c8.44,0,18.48-6.54,18.39-21.33C377.8,147.98,368.22,142.01,359.6,142.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.02,175.95c-1.61,3.79-7.2,13.37-21.52,13.37c-14.41,0-23.7-9.76-23.7-26.26 c0-16.59,10.99-25.41,24.08-25.41c10.14,0,19.25,5.69,21.8,17.35c0.66,3.7,0.66,7.11,0.66,9.19v0.19h-41.52 c-0.1,9.67,5.12,20.67,18.39,20.67c8.82,0,14.6-3.79,17.35-11L441.02,175.95z M437.51,160.21c-0.48-14.12-10.24-18.2-17.82-18.2 c-11.19,0-18.39,7.87-18.77,18.2H437.51z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M475.98,189.31c-17.16,0-24.46-13.08-24.46-25.69c0-12.8,7.49-25.97,24.36-25.97 c17.07,0,23.98,13.37,23.98,25.5C499.87,176.71,491.24,189.31,475.98,189.31 M475.98,141.92c-12.23,0-19.62,8.72-19.62,21.61 c0,11.66,7.21,21.42,19.53,21.42c11.28,0,19.24-10.05,19.15-21.52C494.94,150.64,487.55,141.92,475.98,141.92"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M560.24,189.41c-6.26-1.42-10.14-5.02-12.32-7.3c-3.98-4.08-11.66-17.82-11.66-17.82h-6.92v23.6h-18.39v-66.36 h31c16.97,0,27.49,7.58,27.3,21.14c-0.1,9.76-6.73,16.59-14.41,19.06c2.18,3.41,4.93,8.34,7.96,11.38 c2.47,2.46,5.12,4.55,9.86,6.35L560.24,189.41z M529.34,149.31h14.12c4.17,0,7.39-2.94,7.39-6.64c0-3.88-2.84-6.26-7.68-6.26 h-13.84V149.31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M607.43,187.89v-3.6c-4.08,3.41-8.25,4.93-12.04,4.93c-8.91,0-14.22-3.6-17.16-9.86c-1.33-2.65-1.7-7.2-1.7-11 v-29.29h17.06v28.63c0,4.74,1.61,8.06,6.45,8.06c3.98,0,6.45-2.56,6.54-8.15v-28.53h17.06v48.82H607.43z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M650.83,139.07v3.6c3.41-3.51,8.15-4.93,12.32-4.93c9.2,0,14.69,3.6,17.06,10.9 c0.95,2.84,1.04,6.92,1.04,10.33v28.91h-17.16v-29.39c0-4.27-1.99-7.3-6.54-7.3c-3.79,0-6.35,2.75-6.45,7.39v29.29h-17.06v-48.82 H650.83z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M742.01,189.41c-6.26-1.42-10.14-5.02-12.32-7.3c-3.98-4.08-11.66-17.82-11.66-17.82h-6.92v23.6h-18.39v-66.36 h31c16.97,0,27.49,7.58,27.3,21.14c-0.1,9.76-6.73,16.59-14.41,19.06c2.18,3.41,4.93,8.34,7.96,11.38 c2.47,2.46,5.12,4.55,9.86,6.35L742.01,189.41z M711.11,149.31h14.13c4.17,0,7.4-2.94,7.4-6.64c0-3.88-2.84-6.26-7.68-6.26h-13.84 V149.31z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M789.21,187.89v-3.6c-4.08,3.41-8.25,4.93-12.04,4.93c-8.91,0-14.22-3.6-17.16-9.86c-1.33-2.65-1.7-7.2-1.7-11 v-29.29h17.06v28.63c0,4.74,1.61,8.06,6.45,8.06c3.98,0,6.45-2.56,6.54-8.15v-28.53h17.06v48.82H789.21z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M832.61,139.07v3.6c3.41-3.51,8.15-4.93,12.32-4.93c9.2,0,14.69,3.6,17.06,10.9 c0.95,2.84,1.04,6.92,1.04,10.33v28.91h-17.16v-29.39c0-4.27-1.99-7.3-6.54-7.3c-3.79,0-6.35,2.75-6.45,7.39v29.29h-17.06v-48.82 H832.61z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.5,138.7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.71,145.24l-96.54-55.75c-8.13-4.69-14.78-0.85-14.78,8.53l0.01,2.67v17.67h21.51 c2.96,0,5.36,2.4,5.36,5.36c0,2.96-2.4,5.36-5.36,5.36h-15.41c-0.1-0.01-0.19-0.03-0.3-0.03h-5.82v0.01H68.41 c-2.66,0-4.82,2.16-4.82,4.82c0,2.66,2.16,4.82,4.82,4.82h49.09v-0.01h49.1c2.96,0,5.36,2.4,5.36,5.36c0,2.96-2.4,5.36-5.36,5.36 h-49.2v0.01h-0.01v0.01h-15.43c-2.96,0-5.36,2.4-5.36,5.36c0,2.96,2.4,5.36,5.36,5.36h15.54v-0.01h8.03c2.96,0,5.36,2.4,5.36,5.36 s-2.4,5.36-5.36,5.36h-8.13v0.01h-0.01v0.01H50.68c-2.96,0-5.36,2.4-5.36,5.36c0,2.96,2.4,5.36,5.36,5.36h37.05h29.77v-0.01h31.2 c2.96,0,5.36,2.4,5.36,5.36c0,2.96-2.4,5.36-5.36,5.36h-31.3l-0.01,3.07v14.12c0,9.38,6.65,13.22,14.78,8.53l96.54-55.74 C236.84,157.6,236.84,149.93,228.71,145.24"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M228.71,162.27c8.13-4.69,8.13-12.36,0-17.05l-96.54-55.75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVrr);
export default __webpack_public_path__ + "static/media/logo_vrr.9c8bf6f2b1025e8f7b4c8fe54efbeab9.svg";
export { ForwardRef as ReactComponent };